import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    obtemTextoArray,
} from '../../../business-components/Array/Array'

import {
    ajustaDataStringDDMMYY,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    trataValorTexto,
    trataPercentualTexto,
    trataData,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiPosicaoInvestimentos,
} from './IntegracaoClienteArquivoService'



export const importaPosicaoInvestimentosItau = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    //PDFTxt = PDFTxt.replaceAll('\u0000', 'a')
    //PDFTxt = PDFTxt.replaceAll('Pós-axado', 'Pós-fixado')
    PDFTxt = PDFTxt.replaceAll('Renda Variável', 'Renda-Variável')
    PDFTxt = PDFTxt.replaceAll('Renda Fixa Ativo', 'Renda-Fixa-Ativo')
    //console.log(PDFTxt)



    jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira = HARDCODE.idInstituicaoFinanceiraItau

    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Posição mensal de' + fimLinha, fimLinha,
        HARDCODE.importacaoNumeroConta, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta) {
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Posição a mercado mensal de' + fimLinha, fimLinha,
            HARDCODE.importacaoNumeroConta, true, null, erros, nomeArquivo)
    }
    
    //////obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Patrimônio líquido' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoPatrimonioTotalBruto, true, null, erros, nomeArquivo)

    //////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'A rentabilidade no mês foi de' + fimLinha, fimLinha,
    //////    HARDCODE.importacaoRentabilidadeMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO MÊS:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanhoMes, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO DESDE INÍCIO:' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoGanho24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Positivos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesPositivos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Negativos' + fimLinha, fimLinha,
    ////    HARDCODE.importacaoMesesNegativos, true, null, erros, nomeArquivo)

    ////obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + 'Relatório de Investimentos */espaco + 'Data de referência:' + espaco, fimLinha,
    ////    HARDCODE.importacaoDataReferencia, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Í N D I C E S  D E  R E F E R Ê N C I A' + fimLinha +
    //    'Benchmarks Mês Atual Ano 12M 24M' + fimLinha + 'CDI' + espaco, fimLinha,
    //        HARDCODE.importacaoTaxaCDI12Meses, true, null, erros, nomeArquivo)
    
    //jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses =
    //    trataPercentualTexto(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses.split(espaco)[2])

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CDI (%)' + espaco, fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)

    let linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

    const CDIMes = trataPercentualTexto(linhaDados[0])
    const CDIAno = trataPercentualTexto(linhaDados[1])
    const CDI12M = trataPercentualTexto(linhaDados[2])
    const CDI24M = trataPercentualTexto(linhaDados[3])
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Ativos' + fimLinha + 'Data de' + fimLinha + 'vencto' + fimLinha +
        'Valor aplicado' + fimLinha + ' (R$)' + fimLinha + 'Quantidade PU/Cotação' + fimLinha,
            fimLinha + 'Ativos Quantidade PU/Cotação (R$) Valor (R$) Alocação(%) ReferencialDia',
                HARDCODE.importacaoPosicaoInvestimentos, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Ativos' + fimLinha + 'Data de' + fimLinha + 'vencto' + fimLinha +
            'Valor aplicado' + fimLinha + ' (R$)' + fimLinha + 'Quantidade PU/Cotação' + fimLinha,
                fimLinha + 'Data Evento Valor líquido (R$) PU/Cotação (R$) Quantidade IR (R$) IOF (R$) Custos (R$)',
                    HARDCODE.importacaoPosicaoInvestimentos, true, null, erros, nomeArquivo)
    }

    //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos)

    const linhasPosicaoInvestimentos =
        jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.split(fimLinha)
    let indexLinhasPosicaoInvestimentos

    const posicaoInvestimentos = []

    let posFinalDescricao
    let descricao
    let tipoRecursoFinanceiro
    let valor
    //let percRentabilidadeAnualRecursoFinanceiro
    let dataInicioRecursoFinanceiro = null
    let percRentabilidadeMesRecursoFinanceiro
    let percCDIMesRecursoFinanceiro
    let percRentabilidadeAnoRecursoFinanceiro
    let percCDIAnoRecursoFinanceiro
    let percRentabilidade12MRecursoFinanceiro
    let percCDI12MRecursoFinanceiro
    let percRentabilidade24MRecursoFinanceiro
    let percCDI24MRecursoFinanceiro
    let vencimento = null

    let dadosPosicaoInvestimentos

    indexLinhasPosicaoInvestimentos = 0

    while (indexLinhasPosicaoInvestimentos < linhasPosicaoInvestimentos.length) {

        dadosPosicaoInvestimentos = linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].split(espaco)

        const tipoRecursoFinanceiroAux = pesquisaList(linhaIntegracao.tipoRecursoFinanceiro,
            dadosPosicaoInvestimentos[0]).idConversao

        if (tipoRecursoFinanceiroAux) {

            tipoRecursoFinanceiro = tipoRecursoFinanceiroAux

        } else {

            if (
                    linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].indexOf('/') !== - 1 &&
                    dadosPosicaoInvestimentos.length >= 14 //15
            ) {

                if (dadosPosicaoInvestimentos.length === 14 || dadosPosicaoInvestimentos.length === 15) {

                    dadosPosicaoInvestimentos =
                        (
                            linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos - 2] + espaco +
                            linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos - 1] + espaco +
                            linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos]
                        ).split(espaco)
                }

                vencimento = trataData(ajustaDataStringDDMMYY(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 15]))

                posFinalDescricao = dadosPosicaoInvestimentos.length -
                    (vencimento || dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 15] === '-' ? 16 : 15)

                descricao = obtemTextoArray(dadosPosicaoInvestimentos, 0, posFinalDescricao) 

                valor = trataValorTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 11])

                //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 23].indexOf('-') !== -1) {

                //    valor = valor * -1
                //}

                if (valor === 0) {

                    valor = '0.00'
                }

                dataInicioRecursoFinanceiro =
                    trataData(ajustaDataStringDDMMYY(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 6]))

                percRentabilidadeMesRecursoFinanceiro =
                    trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 5])
                percCDIMesRecursoFinanceiro = round(percRentabilidadeMesRecursoFinanceiro / CDIMes * 100, 2)

                percRentabilidadeAnoRecursoFinanceiro =
                    trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 4])
                percCDIAnoRecursoFinanceiro = round(percRentabilidadeAnoRecursoFinanceiro / CDIAno * 100, 2)

                percRentabilidade12MRecursoFinanceiro =
                    trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3])
                percCDI12MRecursoFinanceiro = round(percRentabilidade12MRecursoFinanceiro / CDI12M * 100, 2)

                percRentabilidade24MRecursoFinanceiro =
                    trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2])
                percCDI24MRecursoFinanceiro = round(percRentabilidade24MRecursoFinanceiro / CDI24M * 100, 2)


                //Não deu certo
                //percRentabilidadeAnualRecursoFinanceiro =
                //    round(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses *
                //        (trataPercentualTexto(dadosPosicaoInvestimentos[10]) / 100), 2)

                //Problema com conversão de taxas negativas
                //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3].indexOf('/')) {

                //    percRentabilidadeAnualRecursoFinanceiro =
                //        converteTaxaMensalEmAnual(
                //            converteTaxaEmMensal(
                //                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2]),
                //                    calculaMeses2Datas(trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3]),
                //                        somaMesesData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataReferencia, -1)
                //                    )
                //            )
                //        )
                //}

                incluiPosicaoInvestimentos(posicaoInvestimentos, tipoRecursoFinanceiro, descricao,
                    valor/*, percRentabilidadeAnualRecursoFinanceiro*/,
                        jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira,
                            dataInicioRecursoFinanceiro, percRentabilidadeMesRecursoFinanceiro, percCDIMesRecursoFinanceiro,
                                percRentabilidadeAnoRecursoFinanceiro, percCDIAnoRecursoFinanceiro,
                                    percRentabilidade12MRecursoFinanceiro, percCDI12MRecursoFinanceiro,
                                        percRentabilidade24MRecursoFinanceiro, percCDI24MRecursoFinanceiro, vencimento)
            }
        }

        indexLinhasPosicaoInvestimentos++
    }

   

    jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos = posicaoInvestimentos
    /*
    erros.push('teste'
        .replace("$numeroProposta$", 'xxx')
            .replace("$codigoAgente$", 'yyy')
    )
    console.log(jsonRegistros)
    */



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}